(() => {
  const configurations = [
    {
      selector: '[data-acha-shelf-carousel]',
      readyAttribute: 'achaShelfCarouselReady',
      trackSelector: '[data-acha-shelf-track]',
      controlsSelector: '[data-acha-shelf-controls]',
      previousSelector: '[data-acha-shelf-previous]',
      nextSelector: '[data-acha-shelf-next]',
      itemSelector: '.lshelf__item',
    },
    {
      selector: '[data-acha-gallery-carousel]',
      readyAttribute: 'achaGalleryCarouselReady',
      trackSelector: '[data-acha-gallery-track]',
      controlsSelector: '[data-acha-gallery-controls]',
      previousSelector: '[data-acha-gallery-previous]',
      nextSelector: '[data-acha-gallery-next]',
      itemSelector: '.acha-gallery__item',
    },
  ];

  const init = (root = document) => {
    configurations.forEach((configuration) => {
      const carousels = root.matches?.(configuration.selector)
        ? [root]
        : Array.from(root.querySelectorAll?.(configuration.selector) || []);

      carousels.forEach((carousel) => {
        if (carousel.dataset[configuration.readyAttribute] === 'true') return;

        const track = carousel.querySelector(configuration.trackSelector);
        const controls = carousel.querySelector(configuration.controlsSelector);
        const previous = carousel.querySelector(configuration.previousSelector);
        const next = carousel.querySelector(configuration.nextSelector);
        if (!track || !controls || !previous || !next) return;

        carousel.dataset[configuration.readyAttribute] = 'true';
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let frame = 0;

        const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);

        const update = () => {
          frame = 0;
          const maximum = maxScroll();
          const position = Math.max(0, track.scrollLeft);
          controls.hidden = maximum <= 2;
          previous.disabled = position <= 2;
          next.disabled = position >= maximum - 2;
        };

        const requestUpdate = () => {
          if (!frame) frame = window.requestAnimationFrame(update);
        };

        const step = (direction) => {
          const items = Array.from(track.querySelectorAll(configuration.itemSelector));
          const firstItem = items[0];
          if (!firstItem) return;

          const position = Math.max(0, track.scrollLeft);
          const maximum = maxScroll();
          const itemPositions = items.map((item) => item.offsetLeft - firstItem.offsetLeft);
          const target = direction > 0
            ? itemPositions.find((itemPosition) => itemPosition > position + 2) ?? maximum
            : itemPositions.slice().reverse().find((itemPosition) => itemPosition < position - 2) ?? 0;

          track.scrollTo({
            left: Math.min(Math.max(0, target), maximum),
            behavior: reducedMotion.matches ? 'auto' : 'smooth',
          });
        };

        previous.addEventListener('click', () => step(-1));
        next.addEventListener('click', () => step(1));
        track.addEventListener('scroll', requestUpdate, { passive: true });
        track.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          step(event.key === 'ArrowLeft' ? -1 : 1);
        });

        const resizeObserver = new ResizeObserver(requestUpdate);
        resizeObserver.observe(track);
        update();
      });
    });
  };

  if (!window.__achaShelfCarouselInit) {
    window.__achaShelfCarouselInit = init;
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  }

  window.__achaShelfCarouselInit(document);
})();
